
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNotAllowed as ObiNotAllowedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-not-allowed.js';
 
 
 

 
 export const ObiNotAllowed = createComponent({
   react: React,
   tagName: 'obi-not-allowed',
   elementClass: ObiNotAllowedElement,
   events: {
     
   }
  });
 
 